import type { OrganizationPreference } from "src/api/organizations/queryPreferences";
import type { CountryEnum } from "src/types/country";
import type { User } from "src/types/user";
import type { BillingAddress } from "./address";
import type { DatabaseData } from "./databaseData";
import type { Id } from "./id";
import type { Pos } from "./pos";
import type { UseQueryStatus } from "./query";
import type { SFBillingTypeEnum, SFContact, SFPaymentTypeEnum, SFUser } from "./sales-force";

export enum OrganizationStatus {
    demo = "demo",
    waiting = "waiting",
    activated = "activated",
    cancelled = "cancelled",
    test = "test",
}

export enum OrganizationDetailsKeys {
    billingCity = "billingCity",
    billingCountry = "billingCountry",
    billingCountryCode = "billingCountryCode",
    billingEmail = "billingEmail",
    billingPostalCode = "billingPostalCode",
    billingStreet = "billingStreet",
    billingType = "billingType",
    countryCode = "countryCode",
    legalName = "legalName",
    name = "name",
    orgaId = "orgaId",
    paymentType = "paymentType",
    recordTypeId = "recordTypeId",
    siren = "siren",
    stripeId = "stripeId",
    vatNumber = "vatNumber",
    companyId = "companyId",
    status = "status",
    contactReferent = "contactReferent",
    id = "id",
}

export interface Organization extends DatabaseData {
    name?: string;
    legalName?: string;
    siren?: number;
    vatNumber?: string;
    companyId?: string;
    isVerified?: boolean;
    countryCode?: CountryEnum;
    status?: OrganizationStatus;
    poss?: Pos[];
    createdDateUTC?: Date;
    countPoss?: number;
    countUsers?: number;
    users?: User[];
    organizationPreferences?: OrganizationPreference[];
}

export interface OrganizationDetails extends Organization, BillingAddress {
    billingEmail?: string;
    billingType?: SFBillingTypeEnum;
    contactReferent?: SFContact;
    legalName?: string;
    name: string;
    orgaId?: number;
    owner?: SFUser;
    paymentType?: SFPaymentTypeEnum;
    recordTypeId?: string;
    siren?: number;
    stripeId?: string;
    vatNumber?: string;
    companyId?: string;
    isBilled: boolean;
    countryCode?: CountryEnum;
    parallelOffersEnabled?: boolean;
    parallelSponsoredAdsEnabled?: boolean;
}

export interface OrganizationExternalPosProps {
    organizationId: Id;
    poss: Pos[];
    statusPoss: UseQueryStatus;
}

export type EnhancedOrganization = Organization & {
    contactReferent?: SFContact;
    owner?: SFUser;
    ownerId?: string;
};
